import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsOverviewComponent } from './settings-overview/settings-overview.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'settings-overview',
        component: SettingsOverviewComponent,
        data: {
          title: 'Settings'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule {
}
